import React, { FunctionComponent, ComponentType } from 'react';
import { Route } from './Route';
import { Redirect, RouteProps } from 'react-router-dom';
import { parse } from 'query-string';

interface ProtectedRouteProps extends RouteProps {
  redirectTo: string;
  when: boolean;
}

export const ProtectedRoute: FunctionComponent<ProtectedRouteProps> = ({
  component,
  when,
  redirectTo,
  children,
  ...props
}) => {
  const Component = component as ComponentType<any>;
  return (
    <Route {...props}>
      {routeProps => (
        <>
          {when && <Redirect to={{
            pathname: redirectTo,
            state: {
              from: window.location.pathname,
              redirect: true,
              props: parse(window.location.search)
            }
          }}  />}
          {!when && (
            <>
              {children ? (
                (children as Function)(routeProps)
              ) : (
                <Component {...routeProps} />
              )}
            </>
          )}
        </>
      )}
    </Route>
  );
};
